import { c as _c } from "react-compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { useSelectionDispatch } from '../../redux/reduxHooks';
import { clearSelection, unselectObjectsNoLongerInTable } from '../../selection/redux/selectionSlice';
import { useResetVisibleIndexes } from '../../virtualization/VirtualizationContext';
const areRowIdsEqual = (currentRows, prevRows) => prevRows && prevRows.length === currentRows.length && prevRows.every((rowId, index) => currentRows[index] === rowId);
export const useResetTableState = t0 => {
  const $ = _c(8);
  const {
    disableScrollReset,
    rowIds,
    tableContainerRef,
    resetObserver
  } = t0;
  const resetVisibleIndexes = useResetVisibleIndexes();
  const prevRowIdsRef = useRef(null);
  const dispatch = useSelectionDispatch();
  let t1;
  let t2;
  if ($[0] !== disableScrollReset || $[1] !== dispatch || $[2] !== resetObserver || $[3] !== resetVisibleIndexes || $[4] !== rowIds || $[5] !== tableContainerRef) {
    t1 = () => {
      if (areRowIdsEqual(rowIds, prevRowIdsRef.current)) {
        return;
      }
      prevRowIdsRef.current = rowIds;
      if (!disableScrollReset) {
        dispatch(clearSelection());
        resetVisibleIndexes();
        if (tableContainerRef.current) {
          tableContainerRef.current.scrollTop = 0;
        }
      } else {
        dispatch(unselectObjectsNoLongerInTable(rowIds));
      }
      resetObserver();
    };
    t2 = [disableScrollReset, dispatch, resetObserver, rowIds, tableContainerRef, resetVisibleIndexes];
    $[0] = disableScrollReset;
    $[1] = dispatch;
    $[2] = resetObserver;
    $[3] = resetVisibleIndexes;
    $[4] = rowIds;
    $[5] = tableContainerRef;
    $[6] = t1;
    $[7] = t2;
  } else {
    t1 = $[6];
    t2 = $[7];
  }
  useLayoutEffect(t1, t2);
};